import * as React from 'react';
import { Hooks } from '@grandvisionhq/payments';
import { useCreateApplePaySession } from '../../modules/ExpressCheckout/hooks/apple-pay/helper-hooks/use-create-apple-pay-session.js';
import { useCreatePaymentRequest } from '../../modules/ExpressCheckout/hooks/apple-pay/helper-hooks/use-create-payment-request.js';
import { useHandleOrderCreation } from './useHandlerOrderCreation.js';
import { useValidateAndSetOrderDetails } from './useValidateAndSetOrderDetails.js';

const useHandleApplePay = ({ selfUrl , donationInfo , consents: consents1 , isSaveDetailsInAccount =false , setIsOrderInProgress ,  })=>{
    const { createApplePaySession  } = useCreateApplePaySession();
    const [createPaymentRequest] = useCreatePaymentRequest(false);
    const [payCartWithApplePayActions] = Hooks.useApplePayWithActions();
    const { handlePlaceOrder  } = useHandleOrderCreation();
    const { saveCustomerInformation  } = useValidateAndSetOrderDetails();
    const createApplePayOrder = React.useCallback(({ paymentToken , selectedPaymentMethod  })=>{
        setIsOrderInProgress(true);
        return handlePlaceOrder({
            selectedPaymentMethod,
            paymentDetails: {
                isValid: true,
                type: selectedPaymentMethod.type,
                data: {
                    applePayToken: paymentToken
                }
            },
            selfUrl,
            consents: consents1,
            donationInfo,
            isSaveDetailsInAccount,
            setIsOrderInProgress
        });
    }, [
        consents1,
        donationInfo,
        setIsOrderInProgress,
        handlePlaceOrder,
        selfUrl,
        isSaveDetailsInAccount, 
    ]);
    const payWithApplePay = React.useCallback(({ selectedShippingMethod , consents  })=>{
        if (selectedShippingMethod.method) {
            saveCustomerInformation(selectedShippingMethod, consents).then(({ success  })=>{
                if (success) {
                    payCartWithApplePayActions({
                        createApplePaySession,
                        createPaymentRequest,
                        completePayment: createApplePayOrder
                    });
                }
            });
        }
    }, [
        createApplePayOrder,
        createApplePaySession,
        createPaymentRequest,
        payCartWithApplePayActions,
        saveCustomerInformation, 
    ]);
    return {
        payWithApplePay
    };
};

export { useHandleApplePay };
//# sourceMappingURL=useHandleApplePay.js.map
